import { PerspectiveCameraProps, useThree } from "@react-three/fiber";
import { useLayoutEffect, useRef } from "react";
import { mergeRefs } from "react-merge-refs";
import { PerspectiveCamera } from "three";

export default function Camera(props: PerspectiveCameraProps) {
    const camRef = useCamera();
    const ref = props.ref ? mergeRefs([camRef, props.ref]) : camRef;
    delete props.ref;
    return <perspectiveCamera ref={ref} {...props} />;
}

export function useCamera() {
    const { set, camera, size } = useThree();
    const ref = useRef<PerspectiveCamera>(null);
    useLayoutEffect(() => {
        if (ref.current) {
            ref.current.aspect = size.width / size.height;
            if (ref.current.updateProjectionMatrix) ref.current.updateProjectionMatrix();
        }
    }, [size]);
    useLayoutEffect(() => {
        if (ref.current) {
            const old = camera;
            //@ts-ignore
            set(() => ({ camera: ref.current }));
            return () => set(() => ({ camera: old }));
        }
    }, [camera, ref, set]);
    return ref;
}